.container {
  display: flex;
}

.main {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  margin-inline-end: -1px;
}

.main:focus {
  position: relative;
  z-index: 0;
}

.option {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.option:focus {
  position: relative;
  z-index: 0;
}

.option--primary,
.option--primary:hover {
  border-left: 1px solid var(--dds-color-border-on-action) !important;
}
